import request from '@/api/request'
import store from '@/store'

export function salesInformationGetSalesInfo(startDate, endDate) {
  return request({
    url: '/salesInfo',
    method: 'get',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region,
    },
    params: { startDate, endDate },
  })
}

